import clsx from "clsx";

import { MdArrowForwardIos } from "react-icons/md";

const NavigationButton = ({ swiperRef, type = "prev" }) => {
  return (
    <button
      onClick={() => {
        type === "prev"
          ? swiperRef.current.slidePrev()
          : swiperRef.current.slideNext();
      }}
      aria-label={type === "prev" ? "previous course" : "next course"}
      name={type}
      className={clsx(
        "absolute top-[46%] -translate-y-[50%] z-10 bg-primary rounded-full h-10 w-10 flex justify-center items-center shadow-lg ",
        type === "prev"
          ? "left-0 -translate-x-1/2 max-sm:ml-1"
          : "right-0 translate-x-1/2 max-sm:mr-1"
      )}>
      {type === "prev" ? (
        <MdArrowForwardIos
          size={22}
          className="rotate-180 text-white bg-primary"
        />
      ) : (
        <MdArrowForwardIos className="text-white  text-xl" />
      )}
    </button>
  );
};

export default NavigationButton;
